<div class="dl-cytocanvas__container dl-modelcanvas__container" #cytoContainer></div>
<div class="dl-modelcanvas__overlaylaag">
    @if (cy) {
        @for (n of nodes(); track n.id()) {
            <dl-node-prullenbak [node]="n" [cy]="cy"></dl-node-prullenbak>
            <dl-node-menu [node]="n" [cy]="cy"></dl-node-menu>
            <dl-node-label [node]="n" [cy]="cy"></dl-node-label>
            <dl-modelnode-hovergroep [node]="n" [cy]="cy"></dl-modelnode-hovergroep>
        }
    }
</div>
<!--
  De uitleg bij een nodemenu-item staat bewust naast de overlaylaag: die kapt af op zijn randen,
  en het uitlegblok is breed. Er is er één voor het hele canvas; welke uitleg getoond wordt komt van
  het menu waar de muis op dat moment overheen gaat.
-->
<dl-node-menu-uitleg [melding]="menuUitleg()" [modelleerniveau]="getEffectiefModelleerniveau()"></dl-node-menu-uitleg>
<!--
  De opmerkingen van de docent bij de nodes, en de editor voor één ervan. Ook naast de overlaylaag: een
  ballon is breed en hoort niet af te kappen op de rand van het canvas. De ballon van de node die bewerkt
  wordt, staat zolang niet in de toonstand.
-->
<div class="dl-modelcanvas__ballonlaag">
    @if (cy) {
        @for (b of ballonnen(); track b.nodeId) {
            @if (b.nodeId !== ballonEdit()?.nodeId && nodeVoor(b.nodeId); as node) {
                <dl-ballon [node]="node" [cy]="cy" modus="toon"
                           [tekst]="b.tekst" [auteur]="b.auteur" [readonly]="fullReadonly()"
                           (wegklik)="wegklikBallon(b.nodeId)"></dl-ballon>
            }
        }
        @if (ballonEditNode(); as node) {
            <dl-ballon [node]="node" [cy]="cy" modus="bewerk" [tekst]="ballonEdit()?.tekst ?? ''"
                       (opslaan)="slaBallonOp($event)" (wegklik)="annuleerBallonEdit()"></dl-ballon>
        }
    }
</div>
<!-- Emptystate van het canvas; blokkeert geen interacties (pointer-events: none) -->
@if (toonEmptystate()) {
    <div class="dl-modelcanvas__emptystate">
        <h2 class="dl-modelcanvas__emptywelkom">{{ 'EMPTYSTATE.welkom' | translate }}</h2>
        <div class="dl-modelcanvas__uitlegbox dl-modelcanvas__uitlegbox--modelacties"
             [innerHTML]="'EMPTYSTATE.modelacties' | translate"></div>
        <div class="dl-modelcanvas__uitlegbox dl-modelcanvas__uitlegbox--drawtoolacties"
             [innerHTML]="'EMPTYSTATE.drawtoolacties' | translate"></div>
        <div class="dl-modelcanvas__uitlegbox dl-modelcanvas__uitlegbox--simacties"
             [innerHTML]="'EMPTYSTATE.simacties' | translate"></div>
        <div class="dl-modelcanvas__uitlegbox dl-modelcanvas__uitlegbox--feedbackbtns"
             [innerHTML]="'EMPTYSTATE.empty_feedbackbtns' | translate"></div>
        <div class="dl-modelcanvas__uitlegbox dl-modelcanvas__uitlegbox--panzoom"
             [innerHTML]="'EMPTYSTATE.empty_panzoom' | translate"></div>
    </div>
}
